import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import { Scale } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardBody } from '@/components/ui/card'
import { EmptyState } from '@/components/ui/empty-state'
import { Skeleton } from '@/components/ui/skeleton'
import { Tabs } from '@/components/ui/tabs'
import { Badge } from '@/components/ui/badge'
import { useDisputeQueue } from '@/features/marketplace/api'
import { formatRelative } from '@/lib/format'

export function MediationPage() {
  const [state, setState] = useState<'open' | 'under_review' | 'resolved'>('open')
  const { data, isLoading } = useDisputeQueue(state)
  const disputes = data?.disputes ?? []

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-extrabold tracking-tight text-ink sm:text-3xl">Mediasi sengketa</h1>
        <p className="mt-1 text-muted">
          Dana milestone yang disengketakan dibekukan sampai putusan Anda terbit.
        </p>
      </header>

      <Tabs
        value={state}
        onChange={setState}
        items={[
          { value: 'open', label: 'Terbuka', count: state === 'open' ? disputes.length : undefined },
          { value: 'under_review', label: 'Ditinjau' },
          { value: 'resolved', label: 'Selesai' },
        ]}
      />

      {isLoading ? (
        <div className="space-y-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} className="h-28 rounded-2xl" />
          ))}
        </div>
      ) : disputes.length === 0 ? (
        <Card>
          <EmptyState
            icon={<Scale className="size-6" />}
            title="Tidak ada sengketa"
            description="Semua kontrak berjalan tanpa perselisihan pada keadaan ini."
          />
        </Card>
      ) : (
        <div className="space-y-3">
          {disputes.map((dispute) => (
            <Card key={dispute.id}>
              <CardBody className="flex flex-wrap items-start justify-between gap-4">
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <Badge tone={dispute.state === 'resolved' ? 'success' : 'danger'}>
                      {dispute.state === 'resolved' ? 'Sudah diputus' : 'Menunggu putusan'}
                    </Badge>
                    <span className="text-xs text-subtle">Diajukan {formatRelative(dispute.created_at)}</span>
                  </div>
                  <p className="clamp-3 mt-2 text-sm leading-relaxed text-muted">{dispute.reason}</p>
                </div>

                <Link to="/app/mediasi/$disputeId" params={{ disputeId: dispute.id }}>
                  <Button size="sm">Tinjau sengketa</Button>
                </Link>
              </CardBody>
            </Card>
          ))}
        </div>
      )}
    </div>
  )
}
